import React, { useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { PartnerCustomerAddForm } from "../../components";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function PartnerAddCustomerPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.usertype === "CP" || user.usertype === "DIST") {
    } else {
      navigate("/");
    }
  });

  const breadcrumbItems = [
    { label: "Home", path: "/", active: false },
    {
      label: "Organization List",
      path: "/partner-customer-info",
      active: false,
    },
    { label: "Create New Organization", path: "#", active: true },
  ];

  return (
    <React.Fragment>
      <Breadcrumb title="Create New Organization" items={breadcrumbItems} />
      <div className={"content-block dx-card responsive-paddings"}>
        <PartnerCustomerAddForm />
      </div>
    </React.Fragment>
  );
}
